import React from 'react';
import ReactDOM from 'react-dom';

function Header(){
    return(
        <div class="pagetitle">
            <h1>Giphy Library</h1>
        </div>
    )
}
export default Header;